export const LOAD_CONTACT_MODES_STARTED = "LOAD_CONTACT_MODES_STARTED";
export const LOAD_CONTACT_MODES_SUCCEEDED = "LOAD_CONTACT_MODES_SUCCEEDED";
export const LOAD_CONTACT_MODES_FAILED = "LOAD_CONTACT_MODES_FAILED";

export const UPDATE_CONTACT_MODES_STARTED = "UPDATE_CONTACT_MODES_STARTED";
export const UPDATE_CONTACT_MODES_SUCCEEDED = "UPDATE_CONTACT_MODES_SUCCEEDED";
export const UPDATE_CONTACT_MODES_FAILED = "UPDATE_CONTACT_MODES_FAILED";
